import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { Checkbox } from "components/common/Checkbox/Checkbox";
import { ColorInput } from "components/common/ColorInput/ColorInput";
import { QuestionIcon } from "components/common/Icons/QuestionIcon";
import { Radio } from "components/common/Radio/Radio";
import { ToolTip } from "components/common/ToolTip/ToolTip";
import { useFillColor } from "./useFillColor";

export const FillColor = () => {
    const {
        color,
        handleColorChange,
        handleShouldFillColorChange,
        shouldFillColor,
        isLocked,
        handleFillColorTypeChange,
        type,
        saveAs,
    } = useFillColor();

    if (isLocked) return null;

    return (
        <div
            className="flex flex-col gap-4 my-4 py-4 px-6 rounded-lg border-irGray-400 dark:border-irGray-200 border"
            data-testid={`fill-color-container`}
        >
            <div className="flex items-center">
                <Checkbox
                    defaultIsChecked={shouldFillColor}
                    handleChange={handleShouldFillColorChange}
                    label={capitalize(translateFunc("background-fill"))}
                    testId="fill-color"
                />
                <div className="ml-auto">
                    <ToolTip text={translateFunc("fill-color-tooltip-text")}>
                        <QuestionIcon />
                    </ToolTip>
                </div>
            </div>

            {shouldFillColor && (
                <>
                    <div className="border-b border-b-irGray-400 w-full"></div>

                    <div className="flex flex-col gap-4">
                        <div className="flex items-center" data-testid={`color-input-container`}>
                            <Radio
                                value={type === "color"}
                                handleClick={() => handleFillColorTypeChange("color")}
                                label={translateFunc("pick-a-color")}
                            />
                            {type === "color" && (
                                <div className="ml-auto flex items-center gap-4">
                                    <ColorInput defaultColor={color} handleChange={handleColorChange} />
                                </div>
                            )}
                        </div>
                        {saveAs !== ".jpg" && (
                            <div className="flex justify-between items-center">
                                <Radio
                                    value={type === "transparent"}
                                    handleClick={() => handleFillColorTypeChange("transparent")}
                                    label={capitalize(translateFunc("transparent"))}
                                />

                                <ToolTip text={translateFunc("transparent-tooltip-text")}>
                                    <QuestionIcon />
                                </ToolTip>
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};
